module.exports = __webpack_public_path__ + "static/media/1.bb82287c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/1.svg
// module id = 229
// module chunks = 1